import { Typography } from "@mui/material";
import { styled } from "@mui/material/styles";

export default styled(Typography)(({ theme }) => ({
  color: theme.palette.primary.light,
  fontWeight: "bold",
}));
